// components/EngravingSection.jsx
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box,
} from "@chakra-ui/react";
import { FaRegEdit } from "react-icons/fa";

const EngravingSection = ({
  product,
  engravingTextMen,
  engravingTextWomen,
  allowRingSize,
  productSet = [],
  isAccordionOpen,
  handleAccordionToggle,
  handleEngravingInput,
}) => {
  if (!product?.canEngrave) return null;

  const isRingOrJewelryCategory = product?.categories?.some((cat) =>
    ["rings", "bracelets", "pendants", "jewellery sets"].includes(cat.name.toLowerCase())
  );

  const isCoupleSubcategory = product?.subcategories?.some((cat) =>
    ["couple rings", "for couples"].includes(cat.name.toLowerCase())
  );

  const isNotPetCollection = product?.productCollections?.some(
    (cat) => cat.name !== "Pet Collection"
  );

  const isPetCollection = product?.productCollections?.some(
    (cat) => cat.name === "Pet Collection"
  );

  const shouldShowSingleEngraving =
    (allowRingSize || productSet.length === 0) && isNotPetCollection;

  const shouldShowPetEngraving = isPetCollection && product?.canEngrave && !product?.canBackEng;

  const renderInput = (label, value, gender) => (
    <>
      <input
        type="text"
        maxLength="10"
        pattern="[A-Za-z]*"
        value={value}
        placeholder={label}
        className="border px-2 py-1 rounded mb-1"
        onChange={(e) => handleEngravingInput(e.target.value, gender)}
      />
      <p className="text-sm text-gray-500 mb-2">Max 10 characters, letters only.</p>
    </>
  );

  const renderAccordion = (children) => (
    <Accordion allowMultiple onChange={() => handleAccordionToggle(!isAccordionOpen)} my="6">
      <AccordionItem>
        <h2>
          <AccordionButton>
            <FaRegEdit className="w-5 h-5" />
            <Box as="span" flex="1" textAlign="left">
              Add Engraving
            </Box>
            <AccordionIcon />
          </AccordionButton>
        </h2>
        <AccordionPanel pb={4}>{children}</AccordionPanel>
      </AccordionItem>
    </Accordion>
  );

  if (isRingOrJewelryCategory && isCoupleSubcategory) {
    return renderAccordion(
      <>
        {renderInput("Engraving For Men", engravingTextMen, "male")}
        {renderInput("Engraving For Women", engravingTextWomen, "female")}
      </>
    );
  }

  if (shouldShowSingleEngraving || shouldShowPetEngraving) {
    const value = product?.gender === "male" ? engravingTextMen : engravingTextWomen;
    return renderAccordion(
      renderInput("Engraving Text", value, product.gender)
    );
  }

  return null;
};

export default EngravingSection;
